<template>
    <!-- HAMBURGER -->

    <div class="burger-wrap" id="burgerWrap">
      <button class="burger-btn" id="burgerBtn" @click="togglePanel()">
        <span></span><span></span><span></span>
      </button>

      <!-- Mega panel latéral -->
      <div class="mega-panel" id="megaPanel">

        <!-- QUOTIDIEN -->
        <div class="mpanel-section">
          <p class="mpanel-label">Quotidien</p>

          <a class="mpanel-item" @click="goToEleve">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#e8f7f1;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" stroke="#1a9e6e" stroke-width="1.5"/><path d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round"/></svg>
              </div>
              Élèves
            </div>
          </a>

          <a @click="goToDossier" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#fef3c7;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M3 7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" stroke="#d97706" stroke-width="1.5"/><path d="M3 7l9 6 9-6" stroke="#d97706" stroke-width="1.5"/></svg>
              </div>
              Dossier
            </div>
          </a>

          <a @click="goToCode" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#eff6ff;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#3b82f6" stroke-width="1.5"/><path d="M8 12h8M8 8h5" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round"/></svg>
              </div>
              Code à livrer
            </div>
          </a>

          <a @click="goToPlanning" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#e8f7f1;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="#1a9e6e" stroke-width="1.5"/><path d="M3 10h18M8 4V2M16 4V2" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round"/></svg>
              </div>
              Planning
            </div>
          </a>

          <!-- Examen avec sous-menu accordéon -->
          <div class="mpanel-item has-sub" id="examItem" @click="toggleSub('examSub','examItem')">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#f5f3ff;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4" stroke="#8b5cf6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="9" stroke="#8b5cf6" stroke-width="1.5"/></svg>
              </div>
              Examen
            </div>
            <svg class="mpanel-chevron" width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div class="mpanel-sub" id="examSub">
            <a @click="goToExCode" class="mpanel-sub-item">
              <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#8b5cf6" stroke-width="1.5"/><path d="M8 12h8M8 8h5" stroke="#8b5cf6" stroke-width="1.5" stroke-linecap="round"/></svg>
              Code
            </a>
            <a @click="goToExConduite" class="mpanel-sub-item">
              <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" stroke="#f43f5e" stroke-width="1.5"/><path d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#f43f5e" stroke-width="1.5" stroke-linecap="round"/></svg>
              Conduite
            </a>
          </div>
        </div>

        <div class="mpanel-sep"></div>

        <!-- OCCASIONNEL -->
        <div class="mpanel-section">
          <p class="mpanel-label">Occasionnel</p>

          <a @click="goToAgence" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#fdf2f8;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="#d946a8" stroke-width="1.5"/></svg>
              </div>
              Agence
            </div>
          </a>

          <a @click="goToLieux" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#ecfdf5;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="#10b981" stroke-width="1.5"/><circle cx="12" cy="10" r="3" stroke="#10b981" stroke-width="1.5"/></svg>
              </div>
              Lieux
            </div>
          </a>

          <a @click="goToPaiements" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#fef9c3;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="#ca8a04" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              Paiements archivés
            </div>
          </a>

          <a @click="goToTransfert" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#eff6ff;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              Transferts élèves
            </div>
          </a>

          <a @click="goToTrame" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#fff7ed;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" stroke="#f97316" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="9" y="3" width="6" height="4" rx="1" stroke="#f97316" stroke-width="1.5"/><path d="M9 12h6M9 16h4" stroke="#f97316" stroke-width="1.5" stroke-linecap="round"/></svg>
              </div>
              Trames de formation
            </div>
          </a>

          <a @click="goToStageCode" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#eff6ff;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#3b82f6" stroke-width="1.5"/><path d="M8 12h8M8 8h5" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round"/></svg>
              </div>
              Stage de code
            </div>
          </a>

          <a @click="goToFonctionnalite" class="mpanel-item">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#fef3c7;">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" stroke="#d97706" stroke-width="1.5"/><path d="M9.5 15a2.5 2.5 0 002.5 2h.5a2 2 0 000-4h-1a2 2 0 010-4h.5a2.5 2.5 0 012.5 2M12 7v1.5M12 15.5V17" stroke="#d97706" stroke-width="1.5" stroke-linecap="round"/></svg>
              </div>
              Fonctionnalité
            </div>
          </a>
        </div>

        <div class="mpanel-sep"></div>

        <!-- DÉCONNEXION -->
        <div @click="deconnexion" class="mpanel-section" style="padding-top:0;">
          <a href="#" class="mpanel-item danger">
            <div class="mpanel-item-left">
              <div class="mpanel-ico" style="background:#fff1f2">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" stroke="#f43f5e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              Déconnexion
            </div>
          </a>
        </div>

      </div>
    </div>
</template>
<script>
export default {
    methods: {

        deconnexion() {
            this.$store.commit("setUser", null);
            this.$store.commit("setToken", null);
            localStorage.removeItem("user_info");
            localStorage.removeItem("user_access");
            this.$router.push({name: 'index'});
        },

        togglePanel() {
            const panel = document.getElementById('megaPanel');
            const btn   = document.getElementById('burgerBtn');
            const isOpen = panel.classList.contains('open');
            if (isOpen) {
            panel.classList.remove('open');
            btn.classList.remove('open');
            } else {
            panel.classList.add('open');
            btn.classList.add('open');
            }
        },

        toggleSub(subId, itemId) {
            const sub  = document.getElementById(subId);
            const item = document.getElementById(itemId);
            const isOpen = sub.classList.contains('open');
            sub.classList.toggle('open', !isOpen);
            item.classList.toggle('sub-open', !isOpen);
        },

        closeAll() {
            document.getElementById('megaPanel').classList.remove('open');
            document.getElementById('burgerBtn').classList.remove('open');
        },

        goToDossier(){
            this.$router.push({ name: "AgenceDossier" });
        },

        goToCode(){
            this.$router.push({ name: "secretaireCode" });
        },

        goToPlanning(){
            this.$router.push({ name: "agence-planning" });
        },

        goToExCode(){
            this.$router.push({ name: "examCode" });
        },

        goToExConduite(){
            this.$router.push({ name: "agence-exam-conduite" });
        },

        goToEleve(){
            this.$router.push({ path: '/AgenceEleve' });
        },

        goToAgence(){
            this.$router.push({ path: '/Donnees' });
        },

        goToLieux(){
            this.$router.push({ path: '/agence/lieux' });
        },

        goToPaiements(){
            this.$router.push({ path: '/OtherPaiementDeleted' });
        },

        goToTransfert(){
            this.$router.push({ path: '/transfert/eleve' });
        },

        goToTrame(){
            this.$router.push({ name: 'trame' });
        },

        goToStageCode(){
            this.$router.push({ name: 'StageCodeAgence' });
        },

        goToFonctionnalite(){
            this.$router.push({ name: 'Fonctionnalite' });
        },

    },
}
</script>
<style scoped>

  /* ===================== NAV ===================== */
  nav {
    background: #fff;
    border-bottom: 1px solid #e2e8f0;
    padding: 0 40px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 300;
  }

  .nav-left { display: flex; align-items: center; gap: 16px; }

  .logo {
    font-family: 'DM Serif Display', serif;
    font-size: 22px;
    color: #1a9e6e;
    letter-spacing: -0.5px;
  }
  .logo span { color: #1a1f2e; }

  .nav-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .nav-date {
    font-size: 13px;
    color: #64748b;
    background: #f4f6f9;
    padding: 6px 14px;
    border-radius: 20px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #1a9e6e;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
  }

  .user-name { font-size: 14px; font-weight: 500; }
  .user-role { font-size: 12px; color: #64748b; }

  .logout {
    font-size: 12px;
    color: #94a3b8;
    text-decoration: none;
    padding: 6px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    transition: all .15s;
  }
  .logout:hover { color: #1a1f2e; border-color: #94a3b8; }

  /* ===================== HAMBURGER ===================== */
  .burger-wrap { position: relative; margin-right: 10px;}

  /* Bouton — style cohérent avec le nav : fond blanc, bordure fine */
  .burger-btn {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 0;
    flex-shrink: 0;
    transition: background .15s, border-color .15s;
  }
  .burger-btn:hover { background: #f4f6f9; border-color: #94a3b8; }

  .burger-btn span {
    display: block;
    width: 16px;
    height: 1.5px;
    background: #1a1f2e;
    border-radius: 2px;
    transition: transform .25s, opacity .2s, width .2s;
    transform-origin: center;
  }

  /* Croix à l'ouverture */
  .burger-btn.open span:nth-child(1) { transform: translateY(5.5px) rotate(45deg); }
  .burger-btn.open span:nth-child(2) { opacity: 0; width: 0; }
  .burger-btn.open span:nth-child(3) { transform: translateY(-5.5px) rotate(-45deg); }

  /* ---- Mega panel (s'ouvre sous le nav) ---- */
  .mega-panel {
    position: fixed;
    top: 5vh; /* hauteur nav */
    left: 0;
    width: 280px;
    background: #ffffff;
    border-right: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
    border-radius: 0 0 16px 0;
    box-shadow: 4px 8px 32px rgba(0,0,0,.07);
    padding: 20px 0 12px;
    display: none;
    z-index: 400;
    transform-origin: top left;
    animation: panelIn .2s ease;
  }
  .mega-panel.open { display: block; }

  @keyframes panelIn {
    from { opacity: 0; transform: translateX(-12px); }
    to   { opacity: 1; transform: translateX(0); }
  }

  /* Section label dans le panel */
  .mpanel-section {
    padding: 0 20px 4px;
    margin-top: 16px;
  }
  .mpanel-section:first-child { margin-top: 0; }

  .mpanel-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: #94a3b8;
    margin-bottom: 4px;
    padding: 0 4px;
  }

  /* Item du panel */
  .mpanel-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 8px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    color: #1a1f2e;
    text-decoration: none;
    cursor: pointer;
    transition: background .12s, color .12s;
    position: relative;
  }
  .mpanel-item:hover { background: #f4f6f9; }
  .mpanel-item.has-sub { justify-content: space-between; }

  .mpanel-item-left { display: flex; align-items: center; gap: 10px; }

  /* Icône colorée dans le panel */
  .mpanel-ico {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .mpanel-chevron {
    color: #94a3b8;
    transition: transform .2s;
    flex-shrink: 0;
  }
  .mpanel-item.sub-open .mpanel-chevron { transform: rotate(90deg); color: #1a9e6e; }

  /* Sous-menu accordéon */
  .mpanel-sub {
    overflow: hidden;
    max-height: 0;
    transition: max-height .22s ease;
  }
  .mpanel-sub.open { max-height: 200px; }

  .mpanel-sub-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 8px 8px 46px;
    border-radius: 8px;
    font-size: 13px;
    color: #64748b;
    text-decoration: none;
    transition: background .12s, color .12s;
  }
  .mpanel-sub-item:hover { background: #f4f6f9; color: #1a1f2e; }

  /* Séparateur */
  .mpanel-sep {
    height: 1px;
    background: #e2e8f0;
    margin: 12px 20px;
  }

  /* Déconnexion */
  .mpanel-item.danger { color: #f43f5e; }
  .mpanel-item.danger:hover { background: #fff1f2; }
</style>